export const QUEUE = 'Snackbar/queue';
export const ADD = 'Snackbar/add';
export const DISMISS = 'Snackbar/dismiss';
